import React from "react";

import crossIcon from "../../../assets/images/crossIcon.png";
import lockIcon from "../../../assets/images/synchronize.png";
import emailIcon from "../../../assets/images/emailIcon.png";
import infoIcon from "../../../assets/images/info_icon.png";
import confidentialIcon from "../../../assets/images/confidential.png";
import key from "../../../assets/images/key.png";
import Verified from "../../../assets/images/verified.png";
import passwordOpenIcon from "../../../assets/images/passwordOpen.png";
import passwordCloseIcon from "../../../assets/images/passwordClose.png";
import infoIconOtp from "../../../assets/images/infoIconOtp.png";
import { makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  Button,
  TextField,
  InputAdornment,
  IconButton,
} from "@material-ui/core";

import OtpInput from "react-otp-input";
import { useOtpResetPopup } from "./useOtpResetPopup";

const useStyles = makeStyles((theme) => ({
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0, 0, 0, 0.5)",
    zIndex: 1300,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContainer: {
    width: "640px",
    height: "480px !important",
    background: "#FFFFFF",
    border: "2px solid #E6E6E6",
    borderRadius: "24px",
    boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.04)",
    padding: "32px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    overflow: "hidden",
    [theme.breakpoints.down("xs")]: {
      width: "353px",
      padding: "20px",
      borderRadius: "24px",
    },
  },
  otpModalContainer: {
    width: "584px",
    height: "480px",
    background: "#FFFFFF",
    border: "1px solid #D9D9D9",
    borderRadius: "12px",
    padding: "24px 32px",
    boxSizing: "border-box",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      width: "353px",
      height: "auto",
      padding: "20px",
    },
  },
  passwordLabel: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "-0.04em",
    color: "#333333",
    marginBottom: "4px",
    textAlign: "left",
    width: "100%",
  },
  disabledGrayBtn: {
    width: "100%",
    width: "348px",
    height: "48px",
    background: "#B8B8B8",
    borderRadius: "8px",
    color: "#FFFFFF",
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    textTransform: "none",
    "&:hover": {
      background: "#B8B8B8",
    },
  },
  requiredStar: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "-0.04em",
    color: "#FF712D",
  },
  passwordInput: {
    width: "100%",
    marginBottom: "16px",
    "& .MuiOutlinedInput-root": {
      width: "520px",
      height: "44px",
      borderRadius: "4px",
      border: "1px solid #E0E0E0",
      padding: "12px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      boxSizing: "border-box",
      background: "#FFFFFF",

      "& fieldset": {
        border: "1px solid #E0E0E0",
      },

      "&:hover fieldset": {
        border: "1px solid #E0E0E0",
      },

      "&.Mui-focused fieldset": {
        border: "1px solid #E0E0E0",
      },
    },
    "& .MuiInputBase-input": {
      fontFamily: "Inter",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "16px",
      letterSpacing: "-0.04em",
      color: "#858585",
      padding: 0,
    },

    "& .MuiInputBase-input::placeholder": {
      color: "#B8B8B8",
      opacity: 1,
      fontFamily: "Inter",
      fontWeight: 500,
      fontSize: "16px",
    },
  },
  visiblePasswordInput: {
    "& .MuiInputBase-input": {
      fontFamily: "Inter",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "-0.04em",
      color: "#3D3D3D",
    },
  },
  borderError: {
    "& .MuiOutlinedInput-root": {
      border: "1px solid #FB6B23 !important",
    },
  },
  passwordHint: {
    width: "520px",
    minHeight: "28px",
    background: "#FFF7EB",
    borderRadius: "4px",
    padding: "4px 4px",
    marginTop: "4px",
    marginBottom: "24px",

    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: "4px",

    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "-0.03em",
    textAlign: "center",
    color: "#858585",
  },
  otpStepText: {
    width: "100%",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "-0.03em",
    color: "#858585",
    textAlign: "left",
  },

  otpLockIcon: {
    width: "48px",
    height: "48px",
    objectFit: "contain",
    marginBottom: "18px",
  },

  otpTitle: {
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "-0.03em",
    color: "#3D3D3D",
    textAlign: "center",
    marginBottom: "12px",
  },
  otpVerifyTitle: {
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "-0.03em",
    color: "#3D3D3D",
    textAlign: "center",
    marginBottom: "12px",
    marginTop: "12px",
  },
  otpSubtitle: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "-0.03em",
    color: "#858585",
    textAlign: "center",
    maxWidth: "520px",
    marginBottom: "24px",
  },
  otpInvalidBox: {
    border: "1px solid #FB6B23 !important",
    background: "#FFF1F0",
    color: "#FB6B23",
  },
  otpconfidentialIcon: {
    width: "48px",
    height: "48px",
    marginTop: "48px",
  },
  otpCloseIcon: {
    position: "absolute",
    top: "16px",
    right: "16px",
    padding: "4px",
  },
  otpCloseImg: {
    width: "11.86px",
    height: "11.87px",
    objectFit: "contain",
    display: "block",
  },
  invalidOtpText: {
    color: "#FB6B23",
    fontSize: "12px",
    fontWeight: 600,
    marginBottom: "12px",
    textAlign: "left",
    width: "348px",
  },

  resendOtpText: {
    color: "#FF712D",
    fontSize: "12px",
    fontWeight: 600,
    marginBottom: "12px",
    textAlign: "left",
    width: "348px",
  },

  otpBtnDisabled: {
    width: "348px",
    height: "48px",
    background: "#CCCCCC",
    borderRadius: "8px",
    color: "#FFFFFF",
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: "16px",
    textTransform: "none",
  },
  otpkeyIcon: {
    width: "48px",
    height: "48px",
    marginBottom: "16px",
  },
  otpEmailBox: {
    width: "100%",
    marginBottom: "8px",

    "& .MuiOutlinedInput-root": {
      height: "44px",
      width: "348px",
      margin: "0 auto",
      display: "flex",
      alignItems: "center",
      borderRadius: "4px",
      background: "#F8F8F8",
      border: "1px solid #E0E0E0",
      paddingLeft: "12px",

      "& fieldset": {
        border: "1px solid #E0E0E0",
      },

      "&.Mui-disabled": {
        background: "#F8F8F8",
      },
    },

    "& .MuiInputBase-input": {
      color: "#858585",
      fontFamily: "Inter",
      fontWeight: 600,
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "-0.04em",
      padding: "10px 0",
    },

    "& .MuiInputBase-input::placeholder": {
      color: "#858585",
      opacity: 1,
      fontFamily: "Inter",
      fontWeight: 600,
      fontSize: "16px",
    },
  },

  otpEmailInfo: {
    width: "100%",
    height: "28px",
    width: "348px",
    background: "#FFF7E8",
    borderRadius: "4px",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "-0.03em",
    color: "#858585",
    textAlign: "center",
    marginBottom: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  otpBtn: {
    width: "100%",
    width: "348px",
    height: "48px",
    background: "#FF712D",
    borderRadius: "8px",
    color: "#FFFFFF",
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    textTransform: "none",
    "&:hover": {
      background: "#FF712D",
    },
    "&:disabled": {
      background: "#B8B8B8",
    },
  },

  otpLaterBtn: {
    marginTop: "16px",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#FF712D",
    textTransform: "none",
  },
  successWrapper: {
    width: "520px",
    minHeight: "172px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "24px",
    textAlign: "center",
    marginTop: "114px",
  },
  otpverifyIcon: {
    width: "48px",
    height: "48px",
    marginBottom: "0px",
  },
  successTitle: {
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "-0.03em",
    color: "#3D3D3D",
  },

  successSubtext: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "-0.03em",
    color: "#858585",
  },
  otpAttempts: {
    marginTop: "4px",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "16px",
    color: "#B8B8B8",
    textAlign: "center",
  },

  otpInputWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    marginBottom: "10px",
  },

  otpBox: {
    width: "44px !important",
    height: "44px",
    background: "#FFFFFF",
    border: "1px solid #858585",
    borderRadius: "4px",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#858585",
    textAlign: "center",
    boxSizing: "border-box",
    marginRight: "12px",

    "&:last-child": {
      marginRight: "0px",
    },
  },
  otpSeparator: {
    display: "inline-block",
    width: "18px",
  },
  otpBoxFocused: {
    border: "1px solid #858585 !important",
    outline: "none",
  },
  otpEmailIcon: {
    width: "20px",
    height: "20px",
    marginRight: "12px",
    objectFit: "contain",
    opacity: 1,
  },
  otpAttemptsIcon: {
    width: "9.99px",
    height: "9.99px",
    color: "#B8B8B8",
    position: "relative",
    bottom: "1px",
    right: "4px",
  },
  otpResendBtn: {
    marginTop: "24px",
    padding: 0,
    minWidth: "unset",
    background: "transparent",
    border: "none",
    boxShadow: "none",
    textTransform: "none",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "-0.03em",
    color: "#858585",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "&:hover": {
      background: "transparent",
    },
  },

  resendHighlight: {
    color: "#FF712D",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "-0.03em",
    marginLeft: "4px",
  },
  resendTimerText: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "-0.03em",
    textAlign: "center",
    color: "#858585",
    marginLeft: "4px",
  },
  resendRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "24px",
  },
  resendRowBtn: {
    padding: 0,
    minWidth: "unset",
    background: "transparent",
    border: "none",
    boxShadow: "none",
    textTransform: "none",
    "&:hover": {
      background: "transparent",
    },
  },
  otpBoxInvalid: {
    width: "44px !important",
    height: "44px",
    background: "#FFFFFF",
    border: "1px solid #FF712D",
    borderRadius: "4px",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#858585",
    textAlign: "center",
    boxSizing: "border-box",
    marginRight: "12px",
  },

  invalidOtpMessage: {
    marginBottom: "12px",
    padding: "8px 12px",
    background: "#FFF3EB",
    borderRadius: "4px",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "-0.03em",
    color: "#FB6B23",
    textAlign: "left",
  },
  infoIconOtp: {
    width: "12px",
    height: "12px",
    marginRight: "4px",
    marginBottom: "2px",
  },
  infoIcon: {
    width: "12px",
    height: "12px",
    marginTop: "3px",
  },
  eyeCloseIcon: {
    width: "18.24px",
    height: "10.08px",
    position: "relative",
    top: "3px",
    left: "2.88px",
    opacity: 1,
    objectFit: "contain",
  },
  eyeOpenIcon: {
    width: "19.97px",
    height: "13.99px",
    position: "relative",
    top: "1px",
    left: "2.02px",
    opacity: 1,
    objectFit: "contain",
  },
}));

const OtpResetPopup = ({ profileRes }) => {
  const classes = useStyles();
  const {
    openOtpModal,
    otpState,
    setOtpState,
    emailInput,
    handleSendOtp,
    handleVerifyOtp,
    handleSetNewPassword,
    isPasswordValid,
    setOpenOtpModal,
    canSkip,
    skipsRemaining,
    handleSkip,
  } = useOtpResetPopup(profileRes);

  if (!openOtpModal) return null;
  return (
    <div className={classes.modalOverlay}>
      <div className={classes.otpModalContainer}>
        {otpState.currentStep === "verification" && (
          <>
            <Typography className={classes.otpStepText}>Step 1 of 3</Typography>

            <img src={lockIcon} alt="lock" className={classes.otpLockIcon} />

            <Typography className={classes.otpTitle}>
              Verify your account to continue
            </Typography>

            <Typography className={classes.otpSubtitle}>
              For your security, please confirm it’s you and set a new password.
              <br />
              It only takes a minute.
            </Typography>

            <TextField
              value={emailInput}
              variant="outlined"
              fullWidth
              disabled
              className={classes.otpEmailBox}
              InputProps={{
                startAdornment: (
                  <img
                    src={emailIcon}
                    alt="email"
                    className={classes.otpEmailIcon}
                  />
                ),
              }}
            />

            <div className={classes.otpEmailInfo}>
              Verification code will be sent to the above email
            </div>

            <Button
              className={classes.otpBtn}
              onClick={handleSendOtp}
              disabled={otpState.otpLoading}
            >
              Get verification code
            </Button>

            {canSkip && (
              <Button className={classes.otpLaterBtn} onClick={handleSkip}>
                Do it later
              </Button>
            )}
            {skipsRemaining > 0 && (
              <div className={classes.otpAttempts}>
                <img
                  src={infoIcon}
                  alt="info"
                  className={classes.otpAttemptsIcon}
                />
                <span>
                  Only {skipsRemaining} attempt
                  {skipsRemaining === 1 ? "" : "s"} remaining
                </span>
              </div>
            )}
          </>
        )}

        {otpState.currentStep === "otp" && (
          <>
            <IconButton
              aria-label="Close modal"
              className={classes.otpCloseIcon}
              onClick={handleSkip}
            >
              <img src={crossIcon} alt="" className={classes.otpCloseImg} />
            </IconButton>

            <Typography className={classes.otpStepText}>Step 2 of 3</Typography>

            <img
              src={confidentialIcon}
              alt="verification"
              className={classes.otpconfidentialIcon}
            />

            <Typography className={classes.otpVerifyTitle}>
              Enter your verification code
            </Typography>

            <Typography className={classes.otpSubtitle}>
              We sent a 6-digit code to your email.
            </Typography>

            <div className={classes.otpInputWrapper}>
              <OtpInput
                value={otpState.otp}
                onChange={(value) => {
                  const numericValue = value.replace(/\D/g, "");
                  setOtpState((prev) => ({
                    ...prev,
                    otp: numericValue,
                    isInvalidOtp: false,
                  }));
                }}
                numInputs={6}
                shouldAutoFocus
                renderInput={(props) => (
                  <input
                    {...props}
                    className={
                      otpState.isInvalidOtp
                        ? classes.otpBoxInvalid
                        : classes.otpBox
                    }
                  />
                )}
                containerStyle={classes.otpInputWrapper}
                inputStyle={classes.otpBox}
                focusStyle={classes.otpBoxFocused}
              />
            </div>

            {otpState.isInvalidOtp && (
              <div className={classes.invalidOtpMessage}>
                <img
                  src={infoIconOtp}
                  alt="info"
                  className={classes.infoIconOtp}
                />
                Invalid code. Please enter the correct code.
              </div>
            )}
            {otpState.error && (
              <div className={classes.invalidOtpMessage}>
                <img
                  src={infoIconOtp}
                  alt="info"
                  className={classes.infoIconOtp}
                />
                {otpState.error}
              </div>
            )}
            <Button
              className={`${classes.otpBtn}`}
              disabled={otpState.otpLoading || otpState.otp.length < 6}
              onClick={handleVerifyOtp}
            >
              Verify code
            </Button>

            <div className={classes.resendRow}>
              <span className={classes.resendTimerText}>
                Didn't get the code?&nbsp;
              </span>
              <Button
                className={classes.resendRowBtn}
                disabled={!otpState.canResendOtp}
                onClick={() => {
                  setOtpState((prev) => ({
                    ...prev,
                    otp: "",
                    isInvalidOtp: false,
                    resendTimer: 59,
                    canResendOtp: false,
                    isResendMode: true,
                  }));

                  handleSendOtp(true);
                }}
              >
                <span
                  className={
                    otpState.isResendMode
                      ? classes.resendTimerText
                      : classes.resendHighlight
                  }
                >
                  {otpState.isResendMode
                    ? `Resend code in ${otpState.resendTimer} secs`
                    : "Resend code"}
                </span>
              </Button>
            </div>
          </>
        )}

        {otpState.currentStep === "password" && (
          <>
            <IconButton
              aria-label="Close modal"
              className={classes.otpCloseIcon}
              onClick={handleSkip}
            >
              <img src={crossIcon} alt="" className={classes.otpCloseImg} />
            </IconButton>

            <Typography className={classes.otpStepText}>Step 3 of 3</Typography>

            <img
              src={
                otpState.isResendMode || otpState.isInvalidOtp ? lockIcon : key
              }
              alt="verification"
              className={classes.otpkeyIcon}
            />

            <Typography className={classes.otpTitle}>
              Set up a new password
            </Typography>

            {/* NEW PASSWORD */}
            <div>
              <Typography className={classes.passwordLabel}>
                New password <span className={classes.requiredStar}>*</span>
              </Typography>

              <TextField
                type={otpState.showPassword ? "text" : "password"}
                value={otpState.newPassword}
                onChange={(e) =>
                  setOtpState((prev) => ({
                    ...prev,
                    newPassword: e.target.value,
                  }))
                }
                variant="outlined"
                fullWidth
                placeholder="Enter new password"
                className={`${classes.passwordInput} ${otpState.showPassword ? classes.visiblePasswordInput : ""
                  } ${!isPasswordValid || otpState.newPassword !== otpState.confirmPassword ? classes.borderError : ""}`}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setOtpState((prev) => ({
                            ...prev,
                            showPassword: !prev.showPassword,
                          }))
                        }
                        edge="end"
                      >
                        <img
                          src={
                            otpState.showPassword
                              ? passwordOpenIcon
                              : passwordCloseIcon
                          }
                          alt="toggle password"
                          className={
                            otpState.showPassword
                              ? classes.eyeOpenIcon
                              : classes.eyeCloseIcon
                          }
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            <div>
              <Typography className={classes.passwordLabel}>
                Confirm password <span className={classes.requiredStar}>*</span>
              </Typography>

              <TextField
                type={otpState.showConfirmPassword ? "text" : "password"}
                value={otpState.confirmPassword}
                onChange={(e) =>
                  setOtpState((prev) => ({
                    ...prev,
                    confirmPassword: e.target.value,
                  }))
                }
                variant="outlined"
                fullWidth
                placeholder="Re-enter new password"
                className={`${classes.passwordInput} ${otpState.showConfirmPassword
                    ? classes.visiblePasswordInput
                    : ""
                  } ${!isPasswordValid || otpState.newPassword !== otpState.confirmPassword ? classes.borderError : ""}`}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setOtpState((prev) => ({
                            ...prev,
                            showConfirmPassword: !prev.showConfirmPassword,
                          }))
                        }
                        edge="end"
                      >
                        <img
                          src={
                            otpState.showConfirmPassword
                              ? passwordOpenIcon
                              : passwordCloseIcon
                          }
                          alt="toggle password"
                          className={
                            otpState.showConfirmPassword
                              ? classes.eyeOpenIcon
                              : classes.eyeCloseIcon
                          }
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            {/* HINT */}

            {otpState.newPassword !== otpState.confirmPassword ? (
              <div className={classes.invalidOtpMessage}>
                <img
                  src={infoIconOtp}
                  alt="info"
                  className={classes.infoIconOtp}
                />
                Passwords do not match. Please make sure both passwords are the
                same.
              </div>
            ) : (
              <div
                className={classes.passwordHint}
                style={{ color: !isPasswordValid ? "#FB6B23" : "" }}
              >
                {isPasswordValid ? (
                  <img src={infoIcon} alt="info" className={classes.infoIcon} />
                ) : (
                  <img
                    src={infoIconOtp}
                    alt="info"
                    className={classes.infoIcon}
                  />
                )}
                Use at least 8 characters, including 1 uppercase letter,
                <br />1 number, and 1 special character.
              </div>
            )}

            {/* BUTTON */}
            <Button
              className={classes.otpBtn}
              disabled={
                otpState.otpLoading ||
                !isPasswordValid ||
                !otpState.newPassword ||
                !otpState.confirmPassword ||
                otpState.newPassword !== otpState.confirmPassword
              }
              onClick={handleSetNewPassword}
            >
              Save and continue
            </Button>
          </>
        )}

        {otpState.currentStep === "success" && (
          <div className={classes.successWrapper}>
            <img
              src={Verified}
              alt="success"
              className={classes.otpverifyIcon}
            />

            <Typography className={classes.successTitle}>
              Your account is verified and password has been reset successfully
            </Typography>

            <Typography className={classes.successSubtext}>
              Please log in again to continue. Redirecting in{" "}
              {otpState.redirectTimer} seconds...
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export default OtpResetPopup;
